import { useAppSelector } from "redux/hooks";

const useError = (): string => {
  const serviceInlineError = useAppSelector(
    (state) => state.serviceInlineError.customError
  );
  const loginError = useAppSelector((state) => state.login.error);
  const otpError = useAppSelector((state) => state.otp.error);
  const merchantError = useAppSelector((state) => state.merchant.error);
  const merchantSwitchError = useAppSelector(
    (state) => state.merchantSwitch.error
  );
  const employeeError = useAppSelector((state) => state.employee.error);
  const employeePhotoError = useAppSelector(
    (state) => state.employeePhoto.error
  );
  const employeeManagementError = useAppSelector(
    (state) => state.employeeManagement.error
  );
  const authListError = useAppSelector((state) => state.authList.error);
  const passRefPersonelInfoError = useAppSelector(
    (state) => state.PassRefPersonelInfo.error
  );
  const passRefCardInfoError = useAppSelector(
    (state) => state.PassRefCardInfo.error
  );
  const integratorListError = useAppSelector(
    (state) => state.IntegratorList.error
  );

  return (
    serviceInlineError ||
    loginError ||
    otpError ||
    merchantError ||
    merchantSwitchError ||
    employeeError ||
    employeePhotoError ||
    employeeManagementError ||
    authListError ||
    passRefPersonelInfoError ||
    passRefCardInfoError ||
    integratorListError
  );
};

export default useError;
